<div class="about-page">
  <app-header-style-seven></app-header-style-seven>

  <div class="custom-container">
    <section class="hero-section">
      <div class="hero-media">
        <img
          src="assets/img/health-coaching/main-banner1.jpg"
          alt="About FMCET Banner"
        />
      </div>
      <div class="hero-overlay"></div>

      <div class="hero-content">
        <div class="hero-copy">
          <span class="hero-kicker">About FMCET</span>
          <h1>Legacy, Leadership & Academic Excellence</h1>
          <p>
            Fatima Michael College of Engineering and Technology stands on a
            strong foundation of service, vision, and educational empowerment,
            shaping students into ethical professionals and future leaders.
          </p>
        </div>

        <div class="hero-quote-card">
          <span class="quote-label">Tamil Wisdom</span>
          <h2>
            தொட்டனைத் தூறும் மணற்கேணி மாந்தர்க்குக்<br />
            கற்றனைத் தூறும் அறிவு
          </h2>
        </div>
      </div>
    </section>

    <section class="section-shell">
      <div class="section-head">
        <span class="section-tag">Institution Profile</span>
        <h2>About Us</h2>
      </div>

      <div class="about-grid">
        <article class="founder-card">
          <div class="founder-image-wrap">
            <img
              src="assets/img/motivation-course/motivation-mission.png"
              alt="Kalvi Rathna Late Ln. Dr. V. Michael"
            />
          </div>
          <p class="founder-caption">
            Kalvi Rathna Late Ln. Dr. V. Michael, B.E., M.I.S.T.E, Ph.D (USA)
          </p>
        </article>

        <article class="content-card legacy-card">
          <h3>The Legacy of Excellence</h3>

          <p>
            The foundation of St. Michael Educational and Charitable Trust was
            laid in 1993 by the visionary Kalvi Rathna Late Ln. Dr. V. Michael,
            B.E., M.I.S.T.E, Ph.D (USA). With a steadfast commitment to
            empowering rural communities, Dr. Michael dedicated his life to
            making quality education accessible to the underprivileged.
          </p>

          <p>
            His dream was to uplift society through technical and professional
            education, instilling values, creativity, and innovation in young
            minds. His relentless efforts and unwavering dedication transformed
            the educational landscape in Sivagangai and beyond, leaving an
            indelible mark on the field of education.
          </p>

          <p>
            Carrying forward this remarkable legacy, his son, Ln. Dr. M. Stalin
            Arockiaraj, Chairman of the St. Michael Group of Institutions, has
            expanded the vision into a dynamic reality. Since establishing
            Fatima Michael College of Engineering and Technology in 2009,
            Dr. Arockiaraj has fostered an environment of excellence, blending
            modern infrastructure with a student-centric approach.
          </p>

          <p>
            Under his leadership, the institution has become a hub of academic
            innovation, nurturing students to achieve their fullest potential
            and contribute meaningfully to society.
          </p>

          <p>
            Together, their combined vision and dedication have created a lasting
            legacy of educational empowerment, inspiring generations to dream
            big, achieve greatness, and make a positive impact on the world.
          </p>
        </article>
      </div>
    </section>

    <section class="section-shell">
      <div class="section-head center-head">
        <span class="section-tag">Quality Commitment</span>
        <h2>Our Quality Policy</h2>
        <p>
          FMCET is committed to be a leader to impart quality education,
          training &amp; research in Science, Engineering, Technology &amp;
          Management with professional staff &amp; infrastructure for developing
          skilled manpower to meet the growing needs of socio-economic progress
          of our nation.
        </p>
      </div>

      <div class="policy-grid">
        <article class="policy-card">
          <span class="policy-number">01</span>
          <p>Providing world class infrastructure facilities.</p>
        </article>

        <article class="policy-card">
          <span class="policy-number">02</span>
          <p>Equipping the facilities with vibrant learning forum.</p>
        </article>

        <article class="policy-card">
          <span class="policy-number">03</span>
          <p>Empowering youth with technical skills &amp; leadership.</p>
        </article>

        <article class="policy-card">
          <span class="policy-number">04</span>
          <p>Providing exuberant teaching &amp; research ambience.</p>
        </article>

        <article class="policy-card">
          <span class="policy-number">05</span>
          <p>
            Networking with global institutions of excellence, industries &amp;
            research organizations.
          </p>
        </article>

        <article class="policy-card">
          <span class="policy-number">06</span>
          <p>
            Engaging through outreach, community development and
            enterpreneurial initiatives.
          </p>
        </article>
      </div>

      <p class="policy-note">
        We shall ensure its continuing suitability by reviewing the quality
        policy periodically in every Management review meeting.
      </p>
    </section>

    <section class="section-shell">
      <div class="section-head center-head">
        <span class="section-tag">Institution Direction</span>
        <h2>Our Vision &amp; Mission</h2>
      </div>

      <div class="vision-mission-grid">
        <article class="vision-box">
          <span class="vision-icon">
            <img src="assets/img/vision-icon.png" alt="Vision Icon" />
          </span>

          <div class="vision-content">
            <h3>Vision</h3>
            <p>
              To be one of the leading and preferred engineering colleges in
              education, research and ethics, and achieve greater recognition
              for our efforts to make the world look to us for technology and
              methodology for future trends and innovations.
            </p>
          </div>
        </article>

        <article class="mission-box">
          <span class="mission-icon">
            <img src="assets/img/mission-icon.png" alt="Mission Icon" />
          </span>

          <div class="mission-content">
            <h3>Mission</h3>
            <p>
              To develop high-quality technical education and technocrats with a
              sound grip on basic engineering principles, technical, and
              managerial skills.
            </p>
            <p>
              To innovate research capabilities, and exemplary professional
              conduct to lead and to use technology for the progress of
              humanity.
            </p>
            <p>
              To adapt themselves to changing technological conditions with the
              highest ethical values.
            </p>
          </div>
        </article>
      </div>
    </section>

    <section class="section-shell">
      <div class="section-head center-head">
        <span class="section-tag">Institution Leadership</span>
        <h2>Our Management Team</h2>
      </div>

      <div class="leaders-grid">
        <article class="leader-card" *ngFor="let message of topMessages">
          <div class="leader-photo">
            <img [src]="message.photo" alt="Management Photo" />
            <p class="leader-caption">{{ message.caption }}</p>
          </div>

          <div class="leader-body">
            <span class="leader-tag">Management Message</span>
            <h3>{{ message.title }}</h3>
            <p>{{ message.content }}</p>
          </div>
        </article>
      </div>

      <div class="section-head center-head inner-head">
        <span class="section-tag">Guiding Minds</span>
        <h2>Our Visionary Leaders</h2>
      </div>

      <div class="leaders-grid">
        <article class="leader-card" *ngFor="let message of bottomMessages">
          <div class="leader-photo">
            <img [src]="message.photo" alt="Leader Photo" />
            <p class="leader-caption">{{ message.caption }}</p>
          </div>

          <div class="leader-body">
            <span class="leader-tag">Leadership Note</span>
            <h3>{{ message.title }}</h3>
            <p>{{ message.content }}</p>
          </div>
        </article>
      </div>
    </section>
  </div>
</div>